import axios from 'axios'

export const authService = {
  profile,
  login,
  logout,
  getUsers,
  loginOTP,
  getFieldUserCandidates,
  addFieldUser,
  addHQUser,
  requestPWChangeOTP,
  changePassword,
  forgotPassword,
  forcedPasswordChange,
}

function profile() {
  return axios.get("/api/profile")
}

function login() {
  return axios.post("/login")
}

function logout() {
  return axios.post("/logout")
}

function getUsers() {
  return axios.get("/api/userlist")
}

function loginOTP(otp) {
  return axios.post('/api/clearotp', {OTP: otp})
}

function getFieldUserCandidates() {
  return axios.get('/api/getfieldusercandidates')
}

function addFieldUser(intID) {
  return axios.post('/api/addfielduser', {InterviewerID: intID})
}

function addHQUser(name, role, cell) {
  return axios.post('/api/addhquser', {
    Username: name,
    Role: role,
    CellphoneNumber: cell,
  })
}

function requestPWChangeOTP() {
  return axios.post('/api/pwchangeotp')
}

function changePassword(currentPW, newPW, otp) {
  return axios.post('/api/changepassword',{
    CurrentPassword: currentPW,
    NewPassword: newPW,
    OTP: otp,
  })
}

function forgotPassword(username) {
  return axios.post('/forgotpassword', {Username: username})
}

function forcedPasswordChange(newPW) {
  return axios.post('/api/forcedpasswordchange', {NewPassword: newPW})
}


// WEBPACK FOOTER //
// ./src/_services/auth.service.js